import React, {
  useEffect, useState, createContext, useContext
} from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

export const PreviousLocationContext = createContext();

// Use this hook with functional React components.
export const usePreviousLocation = () => (useContext(PreviousLocationContext));

// Use this HOC with React class components.
export const withPreviousLocation = (WrappedComponent) => {
  const withLocationComponent = (props) => {
    const previousLocation = usePreviousLocation();

    return <WrappedComponent {...props} previousLocation={previousLocation} />;
  };

  return withLocationComponent;
};

const PreviousLocationProvider = ({ children }) => {
  const location = useLocation();
  const [previousLocation, setPreviousLocation] = useState(null);

  useEffect(() => {
    setPreviousLocation((location));
  }, [location]);

  return (
    <PreviousLocationContext.Provider value={previousLocation}> {children} </PreviousLocationContext.Provider>
  );
};

PreviousLocationProvider.propTypes = {
  children: PropTypes.element.isRequired
};

export default PreviousLocationProvider;
